// Kinyarwanda translations
export const rw: Record<string, string> = {
  'menu.dashboard': 'Ikibaho',
  'menu.customers': 'Abakiriya',
  'menu.products': 'Ibicuruzwa',
  'menu.users': 'Abakoresha',
  'menu.settings': 'Igenamiterere',
  'menu.logout': 'Gusohoka',
  'dashboard.title': 'Ikibaho',
  'dashboard.newOrder': 'Itumiza rishya',
  'order.title': 'Itumiza rishya',
  'order.customer': 'Umukiriya',
  'order.products': 'Ibicuruzwa',
  'order.total': 'Byose',
  'users.title': 'Abakoresha',
  'users.name': 'Izina',
  'users.email': 'Imeri',
  'common.yes': 'Yego',
  'common.no': 'Oya',
  'common.cancel': 'Kureka',
  'common.save': 'Bika',
  'common.search': 'Shakisha',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Kwinjira',
  'login.welcome': 'Murakaza neza, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Imeri',
  'signup.phone': 'Telefone',
  'menu.reportsAndAccounting': 'Raporo n’Ibaruramari',
  'menu.systemAndCommunication': 'Sisitemu n’Itumanaho',
};